import React from 'react'
import { array, arrayOf, object, string } from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import Tour from 'utils/monkey/reactour'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import { lockScroll, unlockScroll } from 'utils/bodyScrollLock'

import BaseTemplate from 'components/templates/BaseTemplate'
import OnboardingTooltip from 'components/molecules/OnboardingTooltip'

import AptitudeResult from './AptitudeResult'
import AptitudeGreeting from './AptitudeGreeting'
import RIASECExplanation from './RIASECExplanation'
import RIASECIntroduction from './RIASECIntroduction'
import AptitudeCareer from './AptitudeCareer'
import AptitudeMajor from './AptitudeMajor'
import AptitudeShare from './AptitudeShare'
import AptitudeBanner from './AptitudeBanner'

class AptitudeReport extends React.Component {
  state = {
    isTourOpen: false,
  }

  componentDidMount() {
    const type = 'aptitude-report'
    if (this.checkTour(type)) {
      const options = {
        headers: { 'X-CSRF-Token': csrfToken() },
      }
      API.post(API.endPoints({ type }).auth.onboarding_tooltip, {}, options).then(() => {
        this.setState({ isTourOpen: true })
      })
    }
  }

  closeTour = () => {
    this.setState({ isTourOpen: false })
  }

  disableBody = () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
    lockScroll()
  }

  enableBody = () => {
    unlockScroll()
  }

  checkTour = (type) => {
    const { onboardingTooltip } = this.props
    return !!(onboardingTooltip && !onboardingTooltip.includes(type))
  }

  render() {
    const {
      careers,
      comment,
      name,
      studyFields,
      ratio,
      } = this.props
    const offsetTop = `${(window.innerHeight / 2 - 180)}px`
    const tourProps = {
      isOpen: this.state.isTourOpen,
      onRequestClose: this.closeTour,
      showNavigation: false,
      showNumber: false,
      showButtons: false,
      showCloseButton: false,
      showNavigationNumber: false,
      disableInteraction: true,
      disableKeyboardNavigation: true,
      rounded: 4,
      closeWithMask: false,
      onAfterOpen: this.disableBody,
      onBeforeClose: this.enableBody,
      steps: [
        {
          selector: '',
          content: () => (
            <OnboardingTooltip
              text="Scroll ke bawah untuk melihat hasil Tes Minat Bakat Kamu selengkapnya"
              arrow="bottom"
              completeFunc={this.closeTour}
            />
          ),
          style: {
            padding: '16px',
            top: offsetTop,
            boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.1)',
          },
        },
      ],
    }

    return (
      <BaseTemplate useNewHeader>
        <Tour {...tourProps} />
        <div className="aptitude-report">
          <AptitudeGreeting name={name} />
          <RIASECIntroduction />
          <RIASECExplanation />
          <AptitudeBanner />
          <AptitudeResult comment={comment} ratio={ratio} />
          <AptitudeCareer careers={careers} />
          <AptitudeMajor majors={studyFields} />
          <AptitudeShare />
          <style jsx>
            {`
              .aptitude-report {
                background-color: #fff;
                :global(&__title) {
                  @media screen and (min-width: 768px) {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;
                    :global(img) {
                      margin-right: 10px;
                    }
                  }
                  @media screen and (max-width: 767px) {
                    :global(img){
                      display: block;
                      margin: auto;
                      height: 77px;
                    }
                  }
                }
                :global(p) {
                  :global(a) {
                    color: #0c2846;
                  }
                }
              }
            `}
          </style>
        </div>
      </BaseTemplate>
    )
  }
}

AptitudeReport.propTypes = {
  careers: arrayOf(object),
  comment: string,
  studyFields: arrayOf(object),
  ratio: object,
  name: string,
  onboardingTooltip: array,
}

export { AptitudeReport }
export default branch({
  careers: ['serverProps', 'careers'],
  comment: ['serverProps', 'comment'],
  name: ['serverProps', 'currentUser', 'name'],
  report: ['serverProps', 'report'],
  ratio: ['serverProps', 'ratio'],
  studyFields: ['serverProps', 'studyFields'],
  onboardingTooltip: ['serverProps', 'currentUser', 'tooltip'],
}, AptitudeReport)
